// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
 * bootstrap-tour - v0.10.2
 * http://bootstraptour.com
 * ========================================================================
 * Copyright 2012-2015 Ulrich Sossou
 *
 * ========================================================================
 * Licensed under the MIT License (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://opensource.org/licenses/MIT
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================================
 */

.tour-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1100;
  background-color: #000;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.tour-step-backdrop {
  position: relative;
  z-index: 1101;
}
.tour-step-backdrop > td {
  position: relative;
  z-index: 1101;
}
.tour-step-background {
  position: absolute !important;
  z-index: 1100;
  background: inherit;
  border-radius: 6px;
}
.popover[class*="tour-"] {
  z-index: 1102;
}
.popover[class*="tour-"] .popover-navigation {
  padding: 9px 14px;
}
.popover[class*="tour-"] .popover-navigation *[data-role="end"] {
  float: right;
}
.popover[class*="tour-"] .popover-navigation *[data-role="prev"],
.popover[class*="tour-"] .popover-navigation *[data-role="next"],
.popover[class*="tour-"] .popover-navigation *[data-role="end"] {
  cursor: pointer;
}
.popover[class*="tour-"] .popover-navigation *[data-role="prev"].disabled,
.popover[class*="tour-"] .popover-navigation *[data-role="next"].disabled,
.popover[class*="tour-"] .popover-navigation *[data-role="end"].disabled {
  cursor: default;
}
.popover[class*="tour-"].orphan {
  position: fixed;
  margin-top: 0;
}
.popover[class*="tour-"].orphan .arrow {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/bootstrap-tour/build/css/bootstrap-tour.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;AACf","sourcesContent":["/* ========================================================================\n * bootstrap-tour - v0.10.2\n * http://bootstraptour.com\n * ========================================================================\n * Copyright 2012-2015 Ulrich Sossou\n *\n * ========================================================================\n * Licensed under the MIT License (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     https://opensource.org/licenses/MIT\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n * ========================================================================\n */\n\n.tour-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1100;\n  background-color: #000;\n  opacity: 0.8;\n  filter: alpha(opacity=80);\n}\n.tour-step-backdrop {\n  position: relative;\n  z-index: 1101;\n}\n.tour-step-backdrop > td {\n  position: relative;\n  z-index: 1101;\n}\n.tour-step-background {\n  position: absolute !important;\n  z-index: 1100;\n  background: inherit;\n  border-radius: 6px;\n}\n.popover[class*=\"tour-\"] {\n  z-index: 1102;\n}\n.popover[class*=\"tour-\"] .popover-navigation {\n  padding: 9px 14px;\n}\n.popover[class*=\"tour-\"] .popover-navigation *[data-role=\"end\"] {\n  float: right;\n}\n.popover[class*=\"tour-\"] .popover-navigation *[data-role=\"prev\"],\n.popover[class*=\"tour-\"] .popover-navigation *[data-role=\"next\"],\n.popover[class*=\"tour-\"] .popover-navigation *[data-role=\"end\"] {\n  cursor: pointer;\n}\n.popover[class*=\"tour-\"] .popover-navigation *[data-role=\"prev\"].disabled,\n.popover[class*=\"tour-\"] .popover-navigation *[data-role=\"next\"].disabled,\n.popover[class*=\"tour-\"] .popover-navigation *[data-role=\"end\"].disabled {\n  cursor: default;\n}\n.popover[class*=\"tour-\"].orphan {\n  position: fixed;\n  margin-top: 0;\n}\n.popover[class*=\"tour-\"].orphan .arrow {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
